import { useLazyLoadQuery } from 'react-relay';
import { SubscriptionPlansQuery } from '@/features/subscription/graphql/SubscriptionPlansQuery';
import type { SubscriptionPlansQuery as SubscriptionPlansQueryType } from '@/__generated__/SubscriptionPlansQuery.graphql';
import { filterVisiblePlans } from '@/features/subscription/utils/filterVisiblePlans';
import type { SavedCard } from '@/features/subscription/utils/cardUi';

/**
 * Lazy-loads the subscription plans query and exposes derived helpers
 * (filtered visible plans, current plan slug, saved cards, payment provider).
 */
export const useSubscriptionPlans = () => {
  const data = useLazyLoadQuery<SubscriptionPlansQueryType>(SubscriptionPlansQuery, {});

  const queryString = typeof window !== 'undefined' ? window.location.search : '';
  const visiblePlans = filterVisiblePlans({ plans: data.subscriptionPlans, queryString });

  const isAsaas = data.activePaymentProvider === 'asaas';
  const currentPlan = data.viewer?.subscription?.plan ?? null;
  const savedCards = (data.viewer?.savedCards ?? []) as unknown as SavedCard[];

  return { data, visiblePlans, isAsaas, currentPlan, savedCards };
};
